import { render, staticRenderFns } from "./MultiSelectSemesters.vue?vue&type=template&id=168fa198"
import script from "./MultiSelectSemesters.vue?vue&type=script&lang=js"
export * from "./MultiSelectSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports